import * as types from './types';

export const setUser = (data) => {
    console.log('setUser', data);
    return {
        type: types.ADD_LOGIN_USER,
        payload: data
    };
};
